$(function ($) {
  console.log('-fl4v10-');

  gsap.registerPlugin(ScrollTrigger);

  // play btn art_section

  var playButtons = document.querySelectorAll('.play_button');
  if (playButtons) {
    playButtons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        console.log('clicked_video_btn');

        var btnId = button.id;
        var sectionId = btnId.split('play_btn__')[1];
        var previewImage = document.getElementById('preview_image_' + sectionId);
        var videoIframe = document.getElementById('video_iframe_' + sectionId);
        var btn = document.getElementById('play_btn__' + sectionId);

        btn.style.display = 'none';
        previewImage.style.display = 'none';
        videoIframe.src += '?autoplay=1';
      });
    });
  }

  //larghezza schermo
  const larghezzaSchermo = window.innerWidth;

  //altezza dinamica sezioni
  if (
    (larghezzaSchermo < 1200 && $('body.index').length) ||
    (larghezzaSchermo < 1200 && $('body.etnz').length) ||
    (larghezzaSchermo < 1200 && $('body.storelocator').length)
  ) {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    if (
      (larghezzaSchermo < 1200 && $('body.index').length) ||
      (larghezzaSchermo < 1200 && $('body.storelocator').length)
    ) {
      //ricalcolo on resize
      window.addEventListener('touchstart', function () {
        if (vh != window.innerHeight * 0.01) {
          vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
        }
      });
    }
  }
  //detect ANDROID device
  if (larghezzaSchermo < 1200) {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      // android users
      $('.index #MainContent').attr('style', 'top:unset;bottom:0;');
      $('.index #MainContent > div.shopify-section:last-child').attr(
        'style',
        'height:100vh!important;overflow-y:scroll!important;'
      );
      $('.index #MainContent > div.shopify-section:last-child footer.footer_next').attr(
        'style',
        'height:100vh!important;overflow-y:scroll!important;'
      );
    } else {
    }
  }

  //snap scroll on mobile:
  //fix footer scroll homepage mobile
  const footerEl = document.querySelector('.index .shopify-section-group-footer-group[id*="next_footer"]');
  const mainSection = document.querySelector('.index #MainContent');
  const mainMobileMenu = document.querySelector('.index .shopify-section-group-header-group');
  //const scrollboxList = $('#MainContent .shopify-section:not(.shopify-section-group-header-group, .shopify-section-group-footer-group)');

  if (larghezzaSchermo < 1200 && $('body.index').length) {
    //scrollboxList.wrapAll('<div class="scrollingbox"></div>');
    mainSection.appendChild(mainMobileMenu);
    mainSection.appendChild(footerEl);
  }

  //SCROLL HIDDEN MENU DESK
  function menuScrollDyHidden() {
    let lastScrollTop = 0; // Memorizza l'ultimo scroll top
    const menuPrincipale = document.querySelector('.shopify-section-group-header-group');

    window.addEventListener(
      'scroll',
      function () {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > lastScrollTop) {
          // Scroll verso il basso
          if (scrollTop > 0) {
            // Solo se scroll diverso da 0
            gsap.to(menuPrincipale, { y: -menuPrincipale.offsetHeight, immediateRender: false, duration: 0.25 });
            menuPrincipale.classList.add('scrolled_menu');
          }
        } else {
          // Scroll verso l'alto
          gsap.to(menuPrincipale, { y: 0, immediateRender: false, duration: 0.25 });
          if (scrollTop <= 0) {
            // Se torniamo a top 0
            menuPrincipale.classList.remove('scrolled_menu');
          }
        }
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // Aggiorna l'ultimo scroll top, ma non lasciarlo mai andare sotto 0
      },
      false
    );
  }
  function menuScrollDyHiddenHP() {
    let lastScrollTop = 0; // Memorizza l'ultimo scroll top
    const menuPrincipale = document.querySelector('.shopify-section-group-header-group');
    const elementoScrollabile = document.querySelector('html');

    // Ascolta l'evento wheel sull'elemento che ha lo scroll, non su window
    elementoScrollabile.addEventListener(
      'wheel',
      function (event) {
        let scrollTop = elementoScrollabile.scrollTop; // Usa scrollTop dell'elemento
        let delta = event.deltaY;

        if (delta > 0) {
          // Scroll verso il basso
          if (scrollTop > 0) {
            gsap.to(menuPrincipale, { y: -menuPrincipale.offsetHeight, immediateRender: false, duration: 0.25 });
            menuPrincipale.classList.add('scrolled_menu');
          }
        } else if (delta < 0) {
          // Scroll verso l'alto
          gsap.to(menuPrincipale, { y: 0, immediateRender: false, duration: 0.25 });
          if (scrollTop <= 0) {
            menuPrincipale.classList.remove('scrolled_menu');
          }
        }
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
      },
      false
    );
  }

  if (larghezzaSchermo > 1199) {
    if (document.body.classList.contains('index')) {
      menuScrollDyHiddenHP();
    } else {
      menuScrollDyHidden();
    }
  }

  //Menu

  //search
  const headerSearch = $('.header__search');

  headerSearch.on('click', function () {
    $('svg.icon-close').on('click', function () {
      $('details').removeAttr('open');
      setTimeout(function () {
        $('html').css('overflow', '');
      }, 100);
    });
    $('html').css('overflow', 'hidden');
  });

  /*barretta sconto Ago2024
  const menuPrincipale = $('.shopify-section-group-header-group');
  const barrettaIT = `<section id="banner_top" style="font-family:Moderat-Bold,sans-serif;position:fixed;background:#000;top:0;left:0;display:flex;justify-content:center;align-items:center;color:#fff;width:100%;height:24px;z-index:99;"><p style="font-family:Moderat-Bold,sans-serif;color:#fff;font-size:12px;letter-spcing:1px;">CONSEGNA GRATUITA fino al 22 settembre!</p></section>`;
  const barrettaITabsolute = `<section id="banner_top" style="font-family:Moderat-Bold,sans-serif;position:absolute;background:#000;top:0;left:0;display:flex;justify-content:center;align-items:center;color:#fff;width:100%;height:20px;z-index:-1;"><p style="font-family:Moderat-Bold,sans-serif;color:#fff;font-size:10px;letter-spcing:1px;">CONSEGNA GRATUITA fino al 22 settembre!</p></section>`;
  const barrettaES = `<section id="banner_top" style="font-family:Moderat-Bold,sans-serif;position:fixed;background:#000;top:0;left:0;display:flex;justify-content:center;align-items:center;color:#fff;width:100%;height:24px;z-index:99;"><p style="font-family:Moderat-Bold,sans-serif;color:#fff;font-size:12px;letter-spcing:1px;">¡ENTREGA GRATUITA hasta el 22 de septiembre!</p></section>`;
  const barrettaESabsolute = `<section id="banner_top" style="font-family:Moderat-Bold,sans-serif;position:absolute;background:#000;top:0;left:0;display:flex;justify-content:center;align-items:center;color:#fff;width:100%;height:20px;z-index:-1;"><p style="font-family:Moderat-Bold,sans-serif;color:#fff;font-size:10px;letter-spcing:1px;">¡ENTREGA GRATUITA hasta el 22 de septiembre!</p></section>`;

  if ($('html').attr('lang') == 'it') {
    if (larghezzaSchermo > 1000) {
      menuPrincipale.css('padding-top', '24px');
      menuPrincipale.prepend(barrettaIT);
    } else {
      menuPrincipale.css({
        'padding-top': '20px',
        height: '80px',
        'max-height': '80px',
      });
      menuPrincipale.prepend(barrettaITabsolute);
      $(
        '.shopify-section-group-header-group #shop_menu .shop_btn, .shopify-section-group-header-group #collections_menu .shop_btn'
      ).css('bottom', '100px');
    }
  } else if ($('html').attr('lang') == 'es') {
    if (larghezzaSchermo > 1000) {
      menuPrincipale.css('padding-top', '24px');
      menuPrincipale.prepend(barrettaES);
    } else {
      menuPrincipale.css({
        'padding-top': '20px',
        height: '80px',
        'max-height': '80px',
      });
      menuPrincipale.prepend(barrettaESabsolute);
      $(
        '.shopify-section-group-header-group #shop_menu .shop_btn, .shopify-section-group-header-group #collections_menu .shop_btn'
      ).css('bottom', '100px');
    }
  }*/

  //Mobile menu
  const shopMenuBtn = $('#shop_menu .lato_box');
  if (shopMenuBtn.length) {
    shopMenuBtn.on('click', function () {
      $(this).parent().toggleClass('open');
      $('#shop_menu > *:not(.shop_btn)').toggleClass('close');
      $('#shop_menu').toggleClass('event_all');

      $('#collections_menu').removeClass('open');

      if ($('#shop_menu').hasClass('event_all')) {
        $('#accessiblyAppWidgetButton').attr('style', 'opacity:0;pointer-events:none;');
      } else {
        $('#accessiblyAppWidgetButton').attr('style', '');
      }

      if ($('.banner_saldi').hasClass('nascondi')) {
        $('.banner_saldi').removeClass('nascondi');
        return;
      }
      if (!$('.banner_saldi').hasClass('nascondi')) {
        $('.banner_saldi').addClass('nascondi');
        return;
      }
    });
  }

  const scrollMenuBtns = $('.scroll_sub_menu > a');
  if (scrollMenuBtns.length) {
    scrollMenuBtns.on('click', function (e) {
      scrollMenuBtns.removeClass('active');
      $('.box_risultati').removeClass('active');

      const $this = $(this);

      if ($this.hasClass('btn_products')) {
        $this.addClass('active');
        $('.risultati_products').addClass('active');
      } else if ($this.hasClass('btn_activities')) {
        $this.addClass('active');
        $('.risultati_activities').addClass('active');
      }
    });
  }

  const itemsMenu = $('.collection_items a.cat_main.has_childs');
  if (itemsMenu.length) {
    itemsMenu.on('click', function (e) {
      e.preventDefault();
      itemsMenu.removeClass('active');
      itemsMenu.next().removeClass('active');
      $(this).addClass('active');
      $(this).next().addClass('active');
    });
  }

  const btnTorna = $('.btn_inner_sub_menu');
  if (btnTorna.length) {
    btnTorna.on('click', function (e) {
      e.preventDefault();
      $(this).parent().parent().removeClass('active');
      $(this).parent().parent().prev().removeClass('active');
      $('.btn_products').trigger('click');
      $('#collections_menu .box_risultati').addClass('active');
    });
  }

  const mobileMenuBtn = $('.mobile_menu_btn .menu-icon_custom');
  if (mobileMenuBtn.length) {
    mobileMenuBtn.on('click', function () {
      $('html').toggleClass('ov_hidden');
      shopMenuBtn.parent().removeClass('open');
      $('#shop_menu').removeClass('event_all');
      $('#shop_menu .shop_sez_bianca_mo').addClass('close');

      $('#collections_menu .shop_sez_bianca_mo').toggleClass('close');
      $('#collections_menu').toggleClass('event_all');
      $('#collections_menu .box_risultati').addClass('active');

      if ($('#collections_menu').hasClass('event_all')) {
        $('#accessiblyAppWidgetButton').attr('style', 'opacity:0;pointer-events:none;');
      } else {
        $('#accessiblyAppWidgetButton').attr('style', '');
      }

      if ($('.banner_saldi').hasClass('nascondi')) {
        $('.banner_saldi').removeClass('nascondi');
        return;
      }
      if (!$('.banner_saldi').hasClass('nascondi')) {
        $('.banner_saldi').addClass('nascondi');
        return;
      }
    });
  }

  //PRODOTTO

  //slider prodotto
  var slider_principale_prodotto = $('.slick_product_page');
  var radioCodiceColore = $('variant-radios fieldset.Color > input');

  slider_principale_prodotto.slick({
    dots: true,
    infinite: false,
    speed: 300,
    centerMode: false,
    variableWidth: true,
    lazyload: true,
    arrows: true,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    prevArrow: `<svg class="prev" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="59.0997" height="59.0997" transform="translate(59.0996 59.0996) rotate(-180)" fill="white" fill-opacity="0.1"/>
    <path d="M28.65 37.3467L31.093 34.9036L26.6072 30.4177L39.0777 30.4248L39.0777 30.381L36.8185 28.1218C36.0824 27.3857 35.0804 26.9678 34.0297 26.9678L26.6022 26.9706L31.0881 22.4847L28.65 20.0466L20 28.6967L28.65 37.3467Z" fill="white"/>
    </svg>`,
    nextArrow: `<svg class="next" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="59.0997" height="59.0997" fill="white" fill-opacity="0.1"/>
    <path d="M30.4496 21.7529L28.0066 24.196L32.4925 28.6819L20.0219 28.6748V28.7186L22.2811 30.9778C23.0172 31.7139 24.0192 32.1318 25.0699 32.1318L32.4974 32.129L28.0115 36.6149L30.4496 39.053L39.0997 30.4029L30.4496 21.7529Z" fill="white"/>
    </svg>`,
    customPaging: function (slider, i) {
      return `<svg class="dot_custom" xmlns="http://www.w3.org/2000/svg" width="18" height="13" viewBox="0 0 18 13" fill="none">
      <path d="M13.994 0C12.924 0 11.897 0.424019 11.133 1.18802L2.53201 9.78201L0.464996 11.848L0 12.313L5.01401 12.313L5.039 12.289L17.317 0L13.994 0Z" fill="white"/>
      </svg>`;
    },
  });

  //Slider secondario
  var slider_secondario_prodotto = $('.slick_product_secondario');
  slider_secondario_prodotto.slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    centerMode: false,
    variableWidth: false,
    arrows: false,
    customPaging: function (slider, i) {
      return `<svg class="dot_custom" xmlns="http://www.w3.org/2000/svg" width="18" height="13" viewBox="0 0 18 13" fill="none">
      <path d="M13.994 0C12.924 0 11.897 0.424019 11.133 1.18802L2.53201 9.78201L0.464996 11.848L0 12.313L5.01401 12.313L5.039 12.289L17.317 0L13.994 0Z" fill="white"/>
      </svg>`;
    },
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 999,
        settings: 'unslick',
      },
    ],
  });

  function controlloSecondoSlider() {
    var nSlide = $('.slick_product_secondario > a:visible').length;
    //è una sola foto?
    if (nSlide == 1) {
      slider_secondario_prodotto.removeClass('piu_di_tre');
      slider_secondario_prodotto.removeClass('dispari');
    }
    //sono più di tre foto?
    if (nSlide > 3) {
      slider_secondario_prodotto.addClass('piu_di_tre');
      slider_secondario_prodotto.removeClass('dispari');
    }
    //sono in numero dispari?
    if (nSlide % 2 !== 0) {
      slider_secondario_prodotto.addClass('dispari');
      slider_secondario_prodotto.removeClass('piu_di_tre');
    }
    //sono più di tre foto E in numero dispari?
    if (nSlide % 2 !== 0 && nSlide > 3) {
      slider_secondario_prodotto.addClass('dispari');
      slider_secondario_prodotto.addClass('piu_di_tre');
    }
  }

  function toggleSlidesByColor() {
    slider_principale_prodotto.slick('slickUnfilter');
    slider_secondario_prodotto.slick('slickUnfilter');
    var codiceColoreAttuale = $('variant-radios fieldset.Color > input:checked');
    var listaSlidesCodiciColore = $(
      '.product__media-item[data-color="' + codiceColoreAttuale.attr('data-color') + '"]'
    );
    var lista2SlidesCodiciColore = $(
      '.slick_product_secondario__item[data-color="' + codiceColoreAttuale.attr('data-color') + '"]'
    );

    var listaCompletaSlideCodiciColore = listaSlidesCodiciColore.add($('.video_slide')).add($('.empty_slide'));
    slider_principale_prodotto.slick('slickFilter', listaCompletaSlideCodiciColore);
    slider_secondario_prodotto.slick('slickFilter', lista2SlidesCodiciColore);
    $('.slick_product_secondario__item').hide();
    $('.slick_product_secondario__item[data-color="' + codiceColoreAttuale.attr('data-color') + '"]').show();
  }

  function renderLookSection() {
    var codiceColoreAttuale = $('variant-radios fieldset.Color > input:checked');
    const $look = $('.section_look_correlato');
    const variantid = codiceColoreAttuale.data('variant_id');

    if ($look.length) {
      $.ajax({
        url: `?section_id=${$look.data('id')}&variant=${variantid}`,
        method: 'GET',
        success: function (data) {
          $look.html(data);
        },
      });
    }
  }

  slider_principale_prodotto.on('reInit', function () {
    if ($('.slick-active[data-video=1]').find('video')[0]) {
      $('.slick-active[data-video=1]').find('video')[0].play();
    }
  });

  toggleSlidesByColor();
  radioCodiceColore.on('click', function () {
    toggleSlidesByColor();
    renderLookSection();
    controlloSecondoSlider();
  });

  controlloSecondoSlider();

  //prezzo e bedge dinamici
  if (larghezzaSchermo > 999) {
    $('.product-form__input input[type="radio"]').on('click', function () {
      setTimeout(function () {
        var priceContent = $('.product__info-container .none_custom .price__container');
        var priceContentVisible = $('.product__info-container .price:not(.none_custom) .price__container');
        priceContentVisible.html(priceContent.html());
        if (priceContent.parent().hasClass('price--on-sale')) {
          priceContentVisible.parent().addClass('price--on-sale');
        } else {
          priceContentVisible.parent().removeClass('price--on-sale');
        }
      }, 1000);
    });
  } else {
    function dynamiDislocatedPrice() {
      setTimeout(function () {
        var priceContent = $('.product__info-container .none_custom .price__container');
        var priceContentVisible = $('.product__info-container .price.mobile .price__container');
        priceContentVisible.html(priceContent.html());
        if (priceContent.parent().hasClass('price--on-sale')) {
          priceContentVisible.parent().addClass('price--on-sale');
        } else {
          priceContentVisible.parent().removeClass('price--on-sale');
        }
      }, 1000);
    }

    dynamiDislocatedPrice();

    $('.product-form__input input[type="radio"]').on('click', function () {
      dynamiDislocatedPrice();
    });
  }

  const radioColori = $(
    '.product-form__input input[name="Colore"], .product-form__input input[name="Color"]'
  ); /* ATTENZIONE NOME INPUT !! */
  if (radioColori.length) {
    function changeProductBG() {
      let valoreDataColor = $('input[name="Colore"]:checked, input[name="Color"]:checked').data(
        'color'
      ); /* ATTENZIONE NOME INPUT !! */
      //console.log(valoreDataColor);
      let urlImmagine = $('.background_url[data-color="' + valoreDataColor + '"]').text();
      //console.log(urlImmagine);
      $('.product__media-wrapper').attr('style', 'background-image: url(' + urlImmagine + ')');
    }

    changeProductBG();
    radioColori.on('change', function () {
      changeProductBG();
    });
  }

  //todo: end matteo

  //info accordion
  const accordion = $('.target_accordion_item .titolo');
  accordion.on('click', function () {
    if ($(this).next('.descrizione').hasClass('open')) {
      $(this).next('.descrizione').toggleClass('open');
      $(this).find('h3').toggleClass('red');
    } else {
      accordion.next('.descrizione').removeClass('open');
      accordion.find('h3').removeClass('red');
      $(this).next('.descrizione').toggleClass('open');
      $(this).find('h3').toggleClass('red');
    }

    const elementOffsetTop = $(this).offset().top;
    $('html').animate(
      {
        scrollTop: elementOffsetTop - 100,
      },
      'slow'
    );
  });

  //SHOP BY
  const coldHot_btnControlli = $('#section_prodotti_cold_hot_shopby .cat_btn.layer');
  const coldHot_boxShopBy = $('#section_prodotti_cold_hot_shopby .prod_card_box');

  coldHot_btnControlli.on('click', function () {
    let $this = $(this);
    let valoreLayer = '';
    let boxesSelezionate = '';

    if ($this.hasClass('layer')) {
      coldHot_btnControlli.removeClass('active');
      $this.addClass('active');
      valoreLayer = $this.data('tipo');
    }

    boxesSelezionate = $('#section_prodotti_cold_hot_shopby .prod_card_box.' + valoreLayer);

    if (boxesSelezionate.hasClass('active')) {
      return;
    } else {
      coldHot_boxShopBy.removeClass('active');
      boxesSelezionate.each(function (i) {
        let $this = $(this);
        setTimeout(function () {
          $this.addClass('active');
        }, 250 * i);
      });
    }
  });

  const waterproof_btnControlliPosiz = $('#section_prodotti_waterproof .cat_btn.posiz');
  const waterproof_boxShopBy = $('#section_prodotti_waterproof .prod_card_box');

  waterproof_btnControlliPosiz.on('click', function () {
    let $this = $(this);
    let valorePosiz = '';
    let boxesSelezionate = '';

    waterproof_btnControlliPosiz.removeClass('active');
    $this.addClass('active');
    valorePosiz = $this.data('tipo');

    boxesSelezionate = $('#section_prodotti_waterproof .prod_card_box.' + valorePosiz);

    if (boxesSelezionate.hasClass('active')) {
      return;
    } else {
      waterproof_boxShopBy.removeClass('active');
      boxesSelezionate.each(function (i) {
        let $this = $(this);
        setTimeout(function () {
          $this.addClass('active');
        }, 250 * i);
      });
    }
  });

  //toggle lang
  const btn_lang = $('.lang_switch_btn');
  const box_lang = $('.lang_switch');
  const box_lang_close = $('.lang_switch .close');
  btn_lang.on('click', (e) => {
    e.preventDefault;
    box_lang.toggleClass('open');
  });
  box_lang_close.on('click', () => {
    box_lang.removeClass('open');
  });

  //stick to top framework
  if (larghezzaSchermo > 999 && $('.product .colonna.vantaggi').length) {
    //const altezzaVantaggi = $('.product .colonna.vantaggi').height();
    //const altezzaSlider = $('.product .colonna.second_slider').height();

    //console.log(altezzaVantaggi);
    //console.log(altezzaSlider);

    /*if(altezzaVantaggi > altezzaSlider){
      $('.product .colonna.second_slider > div').stickThis({
        pushup:'#section_look_correlato',
        top:'80'
      });
    }
    else if(altezzaVantaggi < altezzaSlider){
      $('.product .colonna.vantaggi').stickThis({
        pushup:'#section_look_correlato',
        top:'80'
      });
    }*/

    $('.product .colonna.second_slider > div').stickThis({
      pushup: '.section_look_correlato',
      top: '80',
    });
  }
  if (larghezzaSchermo > 999 && $('.about_wrapper_our_commitment.first_el .box.a h2').length) {
    $('.about_wrapper_our_commitment.first_el .box.a h2').stickThis({
      pushup: '#stop_sticky',
      top: '80',
    });
  }

  //open popup sizechart
  if ($('body.product')) {
    const productChartBtn = $('.product p.product__text a[title="sizechart_btn"]');
    const sizechartClose = $('.product .sizechart .close');
    const sizechartSwitch = $('.sizechart #switch');
    productChartBtn.on('click', function (e) {
      e.preventDefault();
      $('.popup_sizechart').toggleClass('open');
    });
    sizechartClose.on('click', function (e) {
      e.preventDefault();
      $('.popup_sizechart').removeClass('open');
    });
    sizechartSwitch.on('click', function (e) {
      if ($(this).is(':checked')) {
        $('tr[data-zg-role="inches"]').removeClass('hidden');
        $('tr[data-zg-role="cm"]').addClass('hidden');
      } else {
        $('tr[data-zg-role="inches"]').addClass('hidden');
        $('tr[data-zg-role="cm"]').removeClass('hidden');
      }
    });
  }

  //toggle guida alle taglie
  if ($('body.size-guide')) {
    const genere_btn = $('.bottone');
    const tabelle = $('div[data-tab]');

    genere_btn.on('click', function () {
      genere_btn.removeClass('active');
      tabelle.removeClass('open');

      $(this).addClass('active');

      let dataTabBtnValue = $(this).attr('data-tab');
      $('div[data-tab="' + dataTabBtnValue + '"]').addClass('open');
    });

    const toggleSwitches = $('label[for="switch"]');
    toggleSwitches.on('click', function (e) {
      if ($(this).hasClass('inches')) {
        toggleSwitches.removeClass('inches');
      } else {
        toggleSwitches.addClass('inches');
      }
    });
  }

  //toggle about-us
  const vociToggle = $('.voce_toggle');
  const boxToggle = $('.box_toggle');

  if (vociToggle.length) {
    vociToggle.on('click', function () {
      vociToggle.removeClass('active');
      boxToggle.removeClass('active');
      let attributoComune = $(this).attr('data-toggle');
      console.log(attributoComune);
      $(this).addClass('active');
      $('.box_toggle[data-toggle="' + attributoComune + '"]').addClass('active');
    });
  }

  //toggle banner popup TEAMS
  const aboutAthletsItems = $('#section_slam_athletes .about_athletes_slider > div');
  const aboutAthletsItemsBanner = $('#section_slam_athletes .about_athletes_slider > div .banner_team');
  const aboutAthletsItemsBannerClose = $('#section_slam_athletes .banner_team .close');

  let clickStartTime;

  aboutAthletsItems.on('mousedown', function (event) {
    clickStartTime = new Date().getTime();
  });

  aboutAthletsItems.on('mouseup', function (event) {
    const clickEndTime = new Date().getTime();
    const clickDuration = clickEndTime - clickStartTime;

    if (clickDuration < 200 && !$(event.target).hasClass('close')) {
      aboutAthletsItemsBanner.removeClass('open');
      $(this).find('.banner_team').addClass('open');
      aboutAthletsItems.css('opacity', '1');
      $('html').css('overflow', 'hidden');
    }
  });

  aboutAthletsItemsBannerClose.on('click', function (event) {
    event.stopPropagation();
    aboutAthletsItemsBanner.removeClass('open');
    aboutAthletsItems.css('opacity', '');
    $('html').css('overflow', 'auto');
  });

  //popup read more
  const chrono_readMore = $('.about_chrono_text a');
  if (chrono_readMore.length) {
    chrono_readMore.on('click', function (e) {
      e.preventDefault();
      $(this).parent().toggleClass('open');

      if ($(this).parent().hasClass('open')) {
        $(this).text('CLOSE');
      } else {
        $(this).text('READ MORE...');
      }
    });
  }

  //toggle Footer mobile
  if (larghezzaSchermo < 1000) {
    const toggleElementsFooter = $('.menu_footer_next > div');
    toggleElementsFooter.on('click', function () {
      if ($(this).hasClass('open')) {
        $(this).removeClass('open');
        return;
      }
      toggleElementsFooter.removeClass('open');
      $(this).addClass('open');
    });
  }

  if (larghezzaSchermo < 1000 && $('body.product').length && $('button.product-form__submit:not([disabled])').length) {
    const add_to_cart_string = {
      en: 'ADD TO CART',
      de: 'IN DEN WARENKORB',
      es: 'AÑADIR AL CARRITO',
      fr: 'AJOUTER AU PANIER',
      it: 'AGGIUNGI AL CARRELLO',
    };
    const lang = $('html').attr('lang');

    const stickyDiv = $('<div class="add_to_cart_fixed">' + add_to_cart_string[lang] + '</div>');
    $('body.product').append(stickyDiv);

    const addToCartFixed = $('.add_to_cart_fixed');
    const buttonAddtoCart = $('button.product-form__submit');

    addToCartFixed.on('click', function () {
      buttonAddtoCart.trigger('click');
    });

    ScrollTrigger.create({
      trigger: '.product-form',
      start: 'top top',
      endTrigger: '.section_post_correlato',
      end: 'top top',
      onToggle: function (trigger) {
        if (trigger.isActive) {
          addToCartFixed.addClass('attaccato');
          if (document.querySelector('.banner_saldi')) {
            if (window.innerWidth < 1000) {
              addToCartFixed.css('margin-top', '24px');
            }
          }
        } else {
          addToCartFixed.removeClass('attaccato');
        }
      },
    });
  }

  if (larghezzaSchermo < 1000 && $('body.collection').length) {
    const filters = $('.mobile-filter-trigger-section');
    const ordering = $('facet-filters-form.real_mobile');

    ScrollTrigger.create({
      trigger: 'html',
      //start: "top top",
      endTrigger: '#product-grid',
      end: 'bottom top',
      onToggle: function (trigger) {
        if (trigger.isActive) {
          filters.addClass('attaccato');
        } else {
          filters.removeClass('attaccato');
        }
      },
    });

    ScrollTrigger.create({
      trigger: 'html',
      //start: "top top",
      endTrigger: '#product-grid',
      end: 'bottom top',
      onToggle: function (trigger) {
        if (trigger.isActive) {
          ordering.addClass('attaccato');
        } else {
          ordering.removeClass('attaccato');
        }
      },
    });

    const filtersBtn = $('#OpenSidebarBtnMob');
    filtersBtn.on('click', function () {
      $(this).toggleClass('open');
      if ($('aside#main-collection-filters').hasClass('filtersOpen')) {
      }
    });
  }

  if (larghezzaSchermo > 999 && $('body.product').length) {
    const addToCartScroll = $('.product__info-wrapper');
    ScrollTrigger.create({
      trigger: 'form[data-type="add-to-cart-form"]',
      start: 'bottom top',
      endTrigger: '#copyright',
      end: 'top bottom',
      onToggle: function (trigger) {
        if (trigger.isActive) {
          addToCartScroll.addClass('scroll');
          addToCartScroll.removeClass('op_scroll');
        } else {
          addToCartScroll.addClass('scroll_out');
          addToCartScroll.addClass('op_scroll');
          setTimeout(function () {
            addToCartScroll.removeClass('scroll').removeClass('scroll_out');
          }, 500);
        }
      },
    });
  }

  if (larghezzaSchermo > 1199) {
    const liMenuDesk = $('ul.level_1 > li:not(.mo)');
    liMenuDesk.on('click', function () {
      if ($(this).hasClass('open')) {
        liMenuDesk.removeClass('open');
        $('.shopify-section-group-header-group').removeClass('open');
      } else {
        liMenuDesk.removeClass('open');
        $('.shopify-section-group-header-group').addClass('open');
        $(this).addClass('open');
      }
    });
    $(document).on('click', function (event) {
      if (!$(event.target).closest('.level_2').length && !$(event.target).closest('ul.level_1 > li:not(.mo)').length) {
        liMenuDesk.removeClass('open');
        $('.shopify-section-group-header-group').removeClass('open');
      }
    });
    $('#MainContent').on('scroll', function () {
      liMenuDesk.removeClass('open');
      $('.shopify-section-group-header-group').removeClass('open');
    });
    $(document).on('scroll', function () {
      liMenuDesk.removeClass('open');
      $('.shopify-section-group-header-group').removeClass('open');
    });
  }

  //SLIDER ART slider video
  const slider_video = $('.art_slider_video');
  if (slider_video.length) {
    slider_video.slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      centerMode: false,
      variableWidth: false,
      arrows: true,
      prevArrow: `<svg class="prev" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="59.0997" height="59.0997" transform="translate(59.0996 59.0996) rotate(-180)" fill="white" fill-opacity="0.1"/>
      <path d="M28.65 37.3467L31.093 34.9036L26.6072 30.4177L39.0777 30.4248L39.0777 30.381L36.8185 28.1218C36.0824 27.3857 35.0804 26.9678 34.0297 26.9678L26.6022 26.9706L31.0881 22.4847L28.65 20.0466L20 28.6967L28.65 37.3467Z" fill="white"/>
      </svg>`,
      nextArrow: `<svg class="next" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="59.0997" height="59.0997" fill="white" fill-opacity="0.1"/>
      <path d="M30.4496 21.7529L28.0066 24.196L32.4925 28.6819L20.0219 28.6748V28.7186L22.2811 30.9778C23.0172 31.7139 24.0192 32.1318 25.0699 32.1318L32.4974 32.129L28.0115 36.6149L30.4496 39.053L39.0997 30.4029L30.4496 21.7529Z" fill="white"/>
      </svg>`,
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 690,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  //banner saldi
  $(window).on('load', function () {
    var $tickerWrapper = $('.banner_saldi');

    if ($tickerWrapper.length) {
      var $list = $tickerWrapper.find('ul.list');
      var $clonedList = $list.clone();
      var listWidth = 10;

      $list.find('li').each(function (i) {
        listWidth += $(this).outerWidth(true);
      });

      var endPos = $tickerWrapper.width() - listWidth;

      $list.add($clonedList).css({
        width: listWidth + 'px',
      });

      $clonedList.addClass('cloned').appendTo($tickerWrapper);

      //TimelineMax
      var infinite = new TimelineMax({ repeat: -1, paused: true });
      var time = 120;

      infinite
        .fromTo($list, time, { rotation: 0.01, x: 0 }, { force3D: true, x: -listWidth, ease: Linear.easeNone }, 0)
        .fromTo($clonedList, time, { rotation: 0.01, x: listWidth }, { force3D: true, x: 0, ease: Linear.easeNone }, 0)
        .set($list, { force3D: true, rotation: 0.01, x: listWidth })
        .to($clonedList, time, { force3D: true, rotation: 0.01, x: -listWidth, ease: Linear.easeNone }, time)
        .to($list, time, { force3D: true, rotation: 0.01, x: 0, ease: Linear.easeNone }, time)
        .progress(1)
        .progress(0)
        .play();

      //banner saldi - lancio la funzione
      $tickerWrapper
        .on('mouseenter', function () {
          infinite.pause();
        })
        .on('mouseleave', function () {
          infinite.play();
        });

      if (window.innerWidth < 1000) {
        $('body.product div[id*=shopify-block-comparable_products_add_to_compare]').css('top', 'calc(37px - 133vw)');
      }
    }
  });

  //controllo UK
  console.log(Shopify.country);
  if (typeof Shopify !== 'undefined') {
    if (typeof Shopify.country !== 'undefined' && Shopify.country === 'GB') {
      $('body').addClass('country_gb');
    }
  }

  //disclaimer kids prodotto

  const siteLang = $('html').attr('lang');

  if (siteLang == 'en') {
    const kidSizeDisc = `<div class="dis" style="
  font-size: 12px;
  font-style:italic;
  letter-spacing:0;
  ">Info: The child is 138 cm tall and wears size 8</div>`;

    if ($('body.Junior').length) {
      $('a[title="sizechart_btn"]').parent().append(kidSizeDisc);
    }
  } else if (siteLang == 'it') {
    const kidSizeDisc = `<div class="dis" style="
  font-size: 12px;
  font-style:italic;
  letter-spacing:0;
  ">Info: Il bambino è alto 138cm e veste la TG 8</div>`;

    if ($('body.Junior').length) {
      $('a[title="sizechart_btn"]').parent().append(kidSizeDisc);
    }
  } else if (siteLang == 'fr') {
    const kidSizeDisc = `<div class="dis" style="
  font-size: 12px;
  font-style:italic;
  letter-spacing:0;
  ">Info: L'enfant mesure 138 cm et porte la taille 8</div>`;

    if ($('body.Junior').length) {
      $('a[title="sizechart_btn"]').parent().append(kidSizeDisc);
    }
  } else if (siteLang == 'de') {
    const kidSizeDisc = `<div class="dis" style="
  font-size: 12px;
  font-style:italic;
  letter-spacing:0;
  ">Info: Das Kind ist 138 cm groß und trägt Größe 8</div>`;

    if ($('body.Junior').length) {
      $('a[title="sizechart_btn"]').parent().append(kidSizeDisc);
    }
  } else if (siteLang == 'es') {
    const kidSizeDisc = `<div class="dis" style="
  font-size: 12px;
  font-style:italic;
  letter-spacing:0;
  ">Info: El niño mide 138 cm y lleva la talla 8</div>`;

    if ($('body.Junior').length) {
      $('a[title="sizechart_btn"]').parent().append(kidSizeDisc);
    }
  } else {
    const kidSizeDisc = `<div class="dis" style="
  font-size: 12px;
  font-style:italic;
  letter-spacing:0;
  ">Info: The child is 138 cm tall and wears size 8</div>`;

    if ($('body.Junior').length) {
      $('a[title="sizechart_btn"]').parent().append(kidSizeDisc);
    }
  }

  //controllo banner
  if ($('.banner_saldi').length > 0 && larghezzaSchermo > 199) {
    $('.mobile-filter-trigger-section, .facets-vertical-form.mobile-sort').css('margin-top', '24px');
  }

  //aggiungo tooltip "nome colore" alle varianti colore
  function tooltimLabelColore() {}
  if (window.innerWidth > 1000 && $('.product-item-options__item').length) {
    $('.product-item-options__item').on('mouseenter', function (e) {
      console.log('tooltip_hover');

      // Recupera il nome del colore dall'attributo color-name
      var colorName = $(this).attr('color-name');

      // Crea il tooltip e imposta il testo e lo stile
      var $tooltip = $('<div id="color-tooltip"></div>')
        .text(colorName)
        .css({
          'font-size': '12px',
          position: 'absolute',
          background: 'white',
          padding: '2px 4px',
          border: '1px solid black',
          'z-index': 999,
          top: e.pageY + 10 + 'px',
          left: e.pageX + 10 + 'px',
          display: 'none',
        });

      // Aggiungi il tooltip al body e mostralo
      $('body').append($tooltip);
      $tooltip.fadeIn(200);
    });

    // Rimuovi il tooltip quando il mouse esce
    $('.product-item-options__item').on('mouseleave', function () {
      $('#color-tooltip').remove();
    });

    // Aggiorna la posizione del tooltip mentre il mouse si muove
    $('.product-item-options__item').on('mousemove', function (e) {
      $('#color-tooltip').css({
        top: e.pageY + 10 + 'px',
        left: e.pageX + 10 + 'px',
      });
    });

    console.log('tooltip_active');
  }

  //toggle private
  const private_banner = $('.private_disclaimer');
  if (private_banner.length) {
    private_banner.on('click', function () {
      $(this).toggleClass('attivo');
    });
  }

  //section Coll25 - Photp Carousel
  const slider_photo_carousel_custom = $('.photo_carousel_custom');
  if (slider_photo_carousel_custom.length) {
    slider_photo_carousel_custom.slick({
      dots: false,
      speed: 1000,
      slidesToShow: 2,
      centerMode: false,
      variableWidth: false,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 2000,
      prevArrow: `<svg class="prev" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="59.0997" height="59.0997" transform="translate(59.0996 59.0996) rotate(-180)" fill="white" fill-opacity="0.1"/>
      <path d="M28.65 37.3467L31.093 34.9036L26.6072 30.4177L39.0777 30.4248L39.0777 30.381L36.8185 28.1218C36.0824 27.3857 35.0804 26.9678 34.0297 26.9678L26.6022 26.9706L31.0881 22.4847L28.65 20.0466L20 28.6967L28.65 37.3467Z" fill="white"/>
      </svg>`,
      nextArrow: `<svg class="next" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="59.0997" height="59.0997" fill="white" fill-opacity="0.1"/>
      <path d="M30.4496 21.7529L28.0066 24.196L32.4925 28.6819L20.0219 28.6748V28.7186L22.2811 30.9778C23.0172 31.7139 24.0192 32.1318 25.0699 32.1318L32.4974 32.129L28.0115 36.6149L30.4496 39.053L39.0997 30.4029L30.4496 21.7529Z" fill="white"/>
      </svg>`,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
    if ($('.gsap_onscroll').length) {
      setTimeout(() => {
        gsap.to('.gsap_onscroll', {
          y: 200,
          x: -50,
          scrollTrigger: {
            trigger: '.gsap_trigger',
            start: 'top bottom+=' + window.innerHeight * 0.2,
            end: 'bottom top',
            scrub: 2,
            //markers: true,
            invalidateOnRefresh: true,
          },
        });
      }, 1000);
    }
  }

  //section Coll25 - Shop By Concept
  if (larghezzaSchermo > 1199) {
    const boxesArea = $('.area_box');
    if (boxesArea.length) {
      setTimeout(() => {
        gsap.fromTo(
          '.area01, .area03',
          {
            top: '-10px', // Posizione iniziale (rispetto alla sua posizione normale)
          },
          {
            top: '10px', // Posizione finale (rispetto alla sua posizione normale)
            scrollTrigger: {
              trigger: boxesArea.parent(),
              start: 'top bottom+=' + window.innerHeight * -0.2,
              end: 'bottom top+=' + window.innerHeight * 0.2,
              scrub: 1,
              //markers: true,
              invalidateOnRefresh: true,
            },
            ease: 'none', // Importante per lo scrubbing
          }
        );
        gsap.fromTo(
          '.area02, .area04',
          {
            top: '10px', // Posizione iniziale (rispetto alla sua posizione normale)
          },
          {
            top: '-10px', // Posizione finale (rispetto alla sua posizione normale)
            scrollTrigger: {
              trigger: boxesArea.parent(),
              start: 'top bottom+=' + window.innerHeight * -0.2,
              end: 'bottom top+=' + window.innerHeight * 0.2,
              scrub: 1,
              //markers: true,
              invalidateOnRefresh: true,
            },
            ease: 'none', // Importante per lo scrubbing
          }
        );
      }, 1000);
    }
  }

  //section Coll25 - Triple Carousel (slider)
  const slider_triple_carousel = $('.triple_image_box.carousel_v .carousel');
  if (slider_triple_carousel.length) {
    slider_triple_carousel.slick({
      dots: false,
      speed: 1000,
      slidesToShow: 1,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 2000,
      infinite: false,
      prevArrow: `<svg class="prev" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="59.0997" height="59.0997" transform="translate(59.0996 59.0996) rotate(-180)" fill="#000" fill-opacity="0.1"/>
        <path d="M28.65 37.3467L31.093 34.9036L26.6072 30.4177L39.0777 30.4248L39.0777 30.381L36.8185 28.1218C36.0824 27.3857 35.0804 26.9678 34.0297 26.9678L26.6022 26.9706L31.0881 22.4847L28.65 20.0466L20 28.6967L28.65 37.3467Z" fill="white"/>
        </svg>`,
      nextArrow: `<svg class="next" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="59.0997" height="59.0997" fill="#000" fill-opacity="0.1"/>
        <path d="M30.4496 21.7529L28.0066 24.196L32.4925 28.6819L20.0219 28.6748V28.7186L22.2811 30.9778C23.0172 31.7139 24.0192 32.1318 25.0699 32.1318L32.4974 32.129L28.0115 36.6149L30.4496 39.053L39.0997 30.4029L30.4496 21.7529Z" fill="white"/>
        </svg>`,
      /*responsive: [
          {
            breakpoint: 999,
            settings: {
              slidesToShow: 1,
            },
          },
        ],*/
    });
  }

  //section Coll25 - Slider full/w
  const slider_fullw = $('.slider_full_width');
  if (slider_fullw.length) {
    slider_fullw.slick({
      dots: false,
      speed: 1000,
      slidesToShow: 1,
      arrows: true,
      autoplay: false,
      autoplaySpeed: 2000,
      infinite: false,
      prevArrow: `<svg class="prev" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="59.0997" height="59.0997" transform="translate(59.0996 59.0996) rotate(-180)" fill="#000" fill-opacity="0.1"/>
        <path d="M28.65 37.3467L31.093 34.9036L26.6072 30.4177L39.0777 30.4248L39.0777 30.381L36.8185 28.1218C36.0824 27.3857 35.0804 26.9678 34.0297 26.9678L26.6022 26.9706L31.0881 22.4847L28.65 20.0466L20 28.6967L28.65 37.3467Z" fill="white"/>
        </svg>`,
      nextArrow: `<svg class="next" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="59.0997" height="59.0997" fill="#000" fill-opacity="0.1"/>
        <path d="M30.4496 21.7529L28.0066 24.196L32.4925 28.6819L20.0219 28.6748V28.7186L22.2811 30.9778C23.0172 31.7139 24.0192 32.1318 25.0699 32.1318L32.4974 32.129L28.0115 36.6149L30.4496 39.053L39.0997 30.4029L30.4496 21.7529Z" fill="white"/>
        </svg>`,
      /*responsive: [
          {
            breakpoint: 999,
            settings: {
              slidesToShow: 1,
            },
          },
        ],*/
    });
  }

  //section
  const slider_card_box = $('.slider_card_box');
  if (slider_card_box.length) {
    slider_card_box.slick({
      dots: false,
      speed: 1000,
      slidesToShow: 1,
      arrows: true,
      autoplay: false,
      autoplaySpeed: 2000,
      infinite: false,
      prevArrow: `<svg class="prev" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="59.0997" height="59.0997" transform="translate(59.0996 59.0996) rotate(-180)" fill="#000" fill-opacity="0.1"/>
        <path d="M28.65 37.3467L31.093 34.9036L26.6072 30.4177L39.0777 30.4248L39.0777 30.381L36.8185 28.1218C36.0824 27.3857 35.0804 26.9678 34.0297 26.9678L26.6022 26.9706L31.0881 22.4847L28.65 20.0466L20 28.6967L28.65 37.3467Z" fill="white"/>
        </svg>`,
      nextArrow: `<svg class="next" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="59.0997" height="59.0997" fill="#000" fill-opacity="0.1"/>
        <path d="M30.4496 21.7529L28.0066 24.196L32.4925 28.6819L20.0219 28.6748V28.7186L22.2811 30.9778C23.0172 31.7139 24.0192 32.1318 25.0699 32.1318L32.4974 32.129L28.0115 36.6149L30.4496 39.053L39.0997 30.4029L30.4496 21.7529Z" fill="white"/>
        </svg>`,
      /*responsive: [
          {
            breakpoint: 999,
            settings: {
              slidesToShow: 1,
            },
          },
        ],*/
    });
  }

  //filtri orizzontali - bottone new_in
  const btn_new_in = $('.new_in');
  if (btn_new_in.length) {
    btn_new_in.on('click', function (e) {
      e.preventDefault();
      let filtroNewIn = $('details[id*="Details-2"] [for*="new_bedge-1"]');
      filtroNewIn.trigger('click');
    });
  }
  const facets_container = $('.facets-container');
  if (facets_container.length) {
    let parentNewIn = document.querySelector('details[id*="Details-2"] summary.facets__summary');
    parentNewIn.parentElement.setAttribute('open', '');
    parentNewIn.addEventListener('click', function (e) {
      parentNewIn = document.querySelector('details[id*="Details-2"] summary.facets__summary');
      e.preventDefault();
      parentNewIn.setAttribute('open', '');
      console.log('clo');
    });
  }

  // PRIVATE_OFF
  /*console.log('private_off');
  const isProductPage = document.body.classList.contains('product');
  //const is_gb_user = document.body.classList.contains('user_gb');
  function private_sales_product_page() {
    const priceRegularElements = document.querySelectorAll('.product .price__regular');

    priceRegularElements.forEach(function (element) {
      const htmlElement = document.documentElement;
      const lang = htmlElement.lang || htmlElement.getAttribute('lang');

      const logged_user = document.body.classList.contains('logged_user');
      const private_sales_user = document.body.classList.contains('private_sale_active');

      let testoAlert = '';
      let subtestoAlert = '';
      let linkAlert = '';

      if (private_sales_user || logged_user) {
        return;
      }

      if (logged_user) {
        switch (lang) {
          case 'en':
            testoAlert = 'Want to know if this product is discounted?';
            subtestoAlert = 'Subscribe to the newsletter and unlock our Private Sales.';
            linkAlert = 'https://www.slam.com/pages/landing-newsletter';
            break;
          case 'it':
            testoAlert = 'Vuoi sapere se questo prodotto è scontato?';
            subtestoAlert = 'Iscriviti alla newsletter e sblocca i Private Sales.';
            linkAlert = 'https://www.slam.com/it/pages/landing-newsletter';
            break;
          case 'es':
            testoAlert = '¿Quieres saber si este producto tiene descuento?';
            subtestoAlert = 'Suscríbete al boletín y desbloquea las Ventas Privadas.';
            linkAlert = 'https://www.slam.com/es/pages/landing-newsletter';
            break;
          case 'de':
            testoAlert = 'Möchtest du wissen, ob dieses Produkt reduziert ist?';
            subtestoAlert = 'Abonniere den Newsletter und schalte die Private Sales frei.';
            linkAlert = 'https://www.slam.com/de/pages/landing-newsletter';
            break;
          case 'fr':
            testoAlert = 'Vous voulez savoir si ce produit est en réduction ?';
            subtestoAlert = 'Abonnez-vous à la newsletter et accédez aux ventes privées.';
            linkAlert = 'https://www.slam.com/fr/pages/landing-newsletter';
            break;
          default:
            testoAlert = 'Want to know if this product is discounted?';
            subtestoAlert = 'Subscribe to the newsletter and unlock our Private Sales.';
            linkAlert = 'https://www.slam.com/pages/landing-newsletter';
        }
      } else {
        switch (lang) {
          case 'en':
            testoAlert = 'Find out if this product is on sale:';
            subtestoAlert = 'Register and subscribe to the newsletter to access our Private Sales.';
            linkAlert = 'https://www.slam.com/pages/private-sales-subscription';
            break;
          case 'it':
            testoAlert = 'Scopri se questo prodotto è in offerta:';
            subtestoAlert = 'Registrati e iscriviti alla newsletter per accedere ai Private Sales.';
            linkAlert = 'https://www.slam.com/it/pages/private-sales-subscription';
            break;
          case 'es':
            testoAlert = 'Descubre si este producto está en oferta:';
            subtestoAlert = 'Regístrate y suscríbete al boletín para acceder a las Ventas Privadas.';
            linkAlert = 'https://www.slam.com/es/pages/private-sales-subscription';
            break;
          case 'de':
            testoAlert = 'Finde heraus, ob dieses Produkt im Angebot ist:';
            subtestoAlert =
              'Registriere dich und abonniere den Newsletter, um Zugang zu den Private Sales zu erhalten.';
            linkAlert = 'https://www.slam.com/de/pages/private-sales-subscription';
            break;
          case 'fr':
            testoAlert = 'Découvrez si ce produit est en promotion :';
            subtestoAlert = 'Inscrivez-vous et abonnez-vous à la newsletter pour accéder aux ventes privées.';
            linkAlert = 'https://www.slam.com/fr/pages/private-sales-subscription';
            break;
          default:
            testoAlert = 'Find out if this product is on sale:';
            subtestoAlert = 'Register and subscribe to the newsletter to access our Private Sales.';
            linkAlert = 'https://www.slam.com/pages/private-sales-subscription';
        }
      }

      if (!private_sales_user) {
        let alertBannerHTML = `
          <a target="_blank" href="${linkAlert}" class="private_sales_alert_banner">
            <p><strong>${testoAlert}</strong></p>
            <p>${subtestoAlert}</p>
          </a>
        `;
        const alertBanner = document.createRange().createContextualFragment(alertBannerHTML);
        element.appendChild(alertBanner);
      }
    });
  }
  function private_sales_menu_button_conditional_link() {
    const salesButtons = document.querySelectorAll('a.sales');
    const htmlElement = document.documentElement;
    const lang = htmlElement.lang || htmlElement.getAttribute('lang');

    if (salesButtons) {
      const logged_user = document.body.classList.contains('logged_user');
      const private_sales_user = document.body.classList.contains('private_sale_active');

      let linkPrivateSalesButton = '';

      if (private_sales_user || logged_user) {
        return;
      }

      if (logged_user) {
        console.log('logged (newsletter)');
        switch (lang) {
          case 'en':
            linkPrivateSalesButton = 'https://www.slam.com/pages/landing-newsletter';
            break;
          case 'it':
            linkPrivateSalesButton = 'https://www.slam.com/it/pages/landing-newsletter';
            break;
          case 'es':
            linkPrivateSalesButton = 'https://www.slam.com/es/pages/landing-newsletter';
            break;
          case 'de':
            linkPrivateSalesButton = 'https://www.slam.com/de/pages/landing-newsletter';
            break;
          case 'fr':
            linkPrivateSalesButton = 'https://www.slam.com/fr/pages/landing-newsletter';
            break;
          default:
            linkPrivateSalesButton = 'https://www.slam.com/pages/landing-newsletter';
        }
      } else {
        console.log('visitor (subscribe)');
        switch (lang) {
          case 'en':
            linkPrivateSalesButton = 'https://www.slam.com/pages/private-sales-subscription';
            break;
          case 'it':
            linkPrivateSalesButton = 'https://www.slam.com/it/pages/private-sales-subscription';
            break;
          case 'es':
            linkPrivateSalesButton = 'https://www.slam.com/es/pages/private-sales-subscription';
            break;
          case 'de':
            linkPrivateSalesButton = 'https://www.slam.com/de/pages/private-sales-subscription';
            break;
          case 'fr':
            linkPrivateSalesButton = 'https://www.slam.com/fr/pages/private-sales-subscription';
            break;
          default:
            linkPrivateSalesButton = 'https://www.slam.com/pages/private-sales-subscription';
        }
      }

      if (!private_sales_user) {
        salesButtons.forEach((btn) => {
          btn.href = linkPrivateSalesButton;
        });
      }
    }
  }

  if (isProductPage) {
    console.log('private_off is_product');
    private_sales_product_page();
    const variantiButtons = document.querySelectorAll(
      '.product .js.product-form__input.Color input, .product .js.product-form__input.Size input'
    );
    if (variantiButtons) {
      variantiButtons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          setTimeout(function () {
            private_sales_product_page();
          }, 3000);
        });
      });
    }
  }
  private_sales_menu_button_conditional_link();*/

  //filtri main , woman , man , child
  function initGenderFilters() {
    if (!$('body.collection').length) return;

    const SELECTORS = {
      box: '.subcategory-area',
      list: '.facets-layout-list',
      manFor: 'Filter-filter.p.m.custom.gender-1',
      womanFor: 'Filter-filter.p.m.custom.gender-2',
      childFor: 'Filter-filter.p.m.custom.gender-3',
    };

    const labels = (() => {
      if ($('html[lang="it"]').length) return { man: 'uomo', woman: 'donna', child: 'bambino' };
      if ($('html[lang="fr"]').length) return { man: 'homme', woman: 'femme', child: 'jeunesse' };
      if ($('html[lang="de"]').length) return { man: 'mann', woman: 'frau', child: 'jugend' };
      if ($('html[lang="es"]').length) return { man: 'hombre', woman: 'mujer', child: 'juventud' };
      return { man: 'man', woman: 'woman', child: 'youth' };
    })();

    function clickFilterById(forId) {
      const $label = $(`${SELECTORS.list} label[for="${forId}"]`);
      if ($label.length) {
        $label.get(0).click();
        return;
      }
      const $input = $(`${SELECTORS.list} input[id="${forId}"]`);
      if ($input.length) {
        const type = ($input.attr('type') || '').toLowerCase();
        if (type === 'checkbox' || type === 'radio') {
          $input.prop('checked', true).trigger('change');
        } else {
          $input.trigger('change');
        }
      }
    }

    function ensureButtons() {
      const $box = $(SELECTORS.box);
      if (!$box.length) return;

      const exists = (cls) => $box.find(`.${cls}`).length > 0;
      const has = (forId) =>
        $(`${SELECTORS.list} label[for="${forId}"]`).length > 0 ||
        $(`${SELECTORS.list} input[id="${forId}"]`).length > 0;

      const btnHtml = (cls, text) =>
        `<a class="button subcategory-btn body-default ${cls}" 
            style="text-transform:uppercase;background-color:var(--color-nero);color:var(--color-bianco);">
          ${text}
        </a>`;

      if (has(SELECTORS.childFor) && !exists('child_filter')) {
        $box.prepend(btnHtml('child_filter', labels.child));
      }
      if (has(SELECTORS.womanFor) && !exists('woman_filter')) {
        $box.prepend(btnHtml('woman_filter', labels.woman));
      }
      if (has(SELECTORS.manFor) && !exists('man_filter')) {
        $box.prepend(btnHtml('man_filter', labels.man));
      }

      updateActiveClasses();
    }

    function updateActiveClasses() {
      const map = {
        [SELECTORS.manFor]: '.man_filter',
        [SELECTORS.womanFor]: '.woman_filter',
        [SELECTORS.childFor]: '.child_filter',
      };
      Object.keys(map).forEach((forId) => {
        const $input = $(`${SELECTORS.list} input[id="${forId}"]`);
        const $btn = $(map[forId]);
        if ($input.length && $btn.length) {
          if ($input.is(':checked')) {
            $btn.addClass('filtro_attivo');
          } else {
            $btn.removeClass('filtro_attivo');
          }
        }
      });
    }

    $(document).on('click', '.man_filter', function (e) {
      e.preventDefault();
      clickFilterById(SELECTORS.manFor);
      setTimeout(updateActiveClasses, 200);
    });
    $(document).on('click', '.woman_filter', function (e) {
      e.preventDefault();
      clickFilterById(SELECTORS.womanFor);
      setTimeout(updateActiveClasses, 200);
    });
    $(document).on('click', '.child_filter', function (e) {
      e.preventDefault();
      clickFilterById(SELECTORS.childFor);
      setTimeout(updateActiveClasses, 200);
    });

    ensureButtons();
    $(document).on('ajaxComplete', function () {
      ensureButtons();
      updateActiveClasses();
    });
  }
  initGenderFilters();
});
